const c = {
  name: "AutomaticOnboarding",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M14,9c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4c0,2.2-1.8,4-4,4C15.8,13,14,11.2,14,9z M18,7c-1.1,0-2,0.9-2,2
			s0.9,2,2,2c1.1,0,2-0.9,2-2S19.1,7,18,7z"/>
		<path class="st0" d="M26,29H10v-2h16V29z"/>
		<path class="st0" d="M35.4,17l-5.5-3.7l-1.8,1v7.3l1.8,1l5.5-3.7V17z M30,20.1v-4.3l3.2,2.1L30,20.1z"/>
		<path class="st0" d="M32,3v6.1c4.5,0.5,8,4.3,8,8.9c0,4.6-3.5,8.4-8,8.9V33c0,1.7-1.3,3-3,3h-1v1c0,1.7-1.3,3-3,3H3
			c-1.7,0-3-1.3-3-3V7c0-1.7,1.3-3,3-3h1V3c0-1.7,1.3-3,3-3h22C30.7,0,32,1.3,32,3z M6,3v17h5v-2c0-1.7,1.3-3,3-3h8
			c0.2,0,0.3,0,0.5,0c1.1-3.2,4-5.6,7.5-6V3c0-0.5-0.5-1-1-1H7C6.5,2,6,2.5,6,3z M13,20h9.2c-0.1-0.6-0.2-1.3-0.2-2
			c0-0.3,0-0.7,0.1-1c0,0,0,0-0.1,0h-8c-0.5,0-1,0.5-1,1V20z M22.9,22H6v11c0,0.5,0.5,1,1,1h22c0.5,0,1-0.5,1-1v-6.1
			C26.9,26.6,24.3,24.7,22.9,22z M26,36H7c-1.7,0-3-1.3-3-3V6H3C2.5,6,2,6.5,2,7v30c0,0.5,0.5,1,1,1h22c0.5,0,1-0.5,1-1V36z M31,11
			c-3.9,0-7,3.1-7,7s3.1,7,7,7s7-3.1,7-7S34.9,11,31,11z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as AutomaticOnboarding
};
